import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyQuestionPage from "@/pages/admin/surveys/detail/questions/detail";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/questions/$questionId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { surveyId, questionId } = Route.useParams();
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyQuestionPage
      surveyId={surveyId}
      questionId={questionId}
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
